import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Home } from "../pages/Home";
import { GenerateInsights } from "../pages/GenerateInsights";
import { GenerateBenchmarks } from "../pages/GenerateBenchmarks";
import { NothingFoundBackground } from "../pages/NotFound";
import { GenerateSuppliers } from "../pages/GenerateSuppliers";
import { Iterator } from "../pages/AiToolkit/Iterator";
import { Translator } from "../pages/AiToolkit/Translator";
import { Redaction } from "../pages/AiToolkit/Redaction";
import { SupplierDemandConstants } from "../pages/AiToolkit/SupplierDemandConstants";
import { Login } from "../pages/UserLogin";
import { ProtectedRoute } from "../@components/Auth/ProtectedRoute";
import { AuthProvider } from "../@components/Auth/AuthProvider";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { NavBar } from "../@components/Navigation/NavBar";
import { Box } from "@mui/material";
import { DemandConstantsForm } from "../@components/AiToolkit/SupplierDemand/DemandConstantsForm";
import { SupplyConstantsForm } from "../@components/AiToolkit/SupplierDemand/SupplyConstantsForm";

export const AllRoutes = () => {
  const queryClient = new QueryClient();

  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <Box sx={{ overflow: "hidden" }}>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route
                path="/Home"
                element={
                  <ProtectedRoute>
                    <NavBar />
                    <Home />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/GenerateInsights"
                element={
                  <ProtectedRoute>
                    <NavBar />
                    <GenerateInsights />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/GenerateBenchmarks"
                element={
                  <ProtectedRoute>
                    <NavBar />
                    <GenerateBenchmarks />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/GenerateSuppliers"
                element={
                  <ProtectedRoute>
                    <NavBar />
                    <GenerateSuppliers />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/AiToolkit/Iterator"
                element={
                  <ProtectedRoute>
                    <NavBar />
                    <Iterator />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/AiToolkit/Translator"
                element={
                  <ProtectedRoute>
                    <NavBar />
                    <Translator />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/AiToolkit/Redaction"
                element={
                  <ProtectedRoute>
                    <NavBar />
                    <Redaction />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/AiToolkit/Supplier_Demand_Constants"
                element={
                  <ProtectedRoute>
                    <NavBar />
                    <SupplierDemandConstants />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/AiToolkit/Supply_Constants"
                element={
                  <ProtectedRoute>
                    <NavBar />
                    <SupplyConstantsForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/AiToolkit/Demand_Constants"
                element={
                  <ProtectedRoute>
                    <NavBar />
                    <DemandConstantsForm />
                  </ProtectedRoute>
                }
              />

              <Route path="*" element={<NothingFoundBackground />} />
            </Routes>
          </Box>
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
};
